
<template>
  <div id="page-holiday-list">
    <vs-card>

      <template slot="header">
        <div style=" display: flex;">
          <vs-button to="/pages/holiday/policies/add" icon-pack="feather" icon="icon-plus" color="primary" type="filled"
            class="mb-2 mt-2 ml-2">
            Adicionar Politica
          </vs-button>


        </div>
      </template>


      <vs-table search stripe :data="policies" :max-items="paginate">

        <template slot="thead">
          <vs-th style="background-color: #ebe9f1;" sort-key="employee">#</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="department">Anos de Trabalho</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="start_date">Dias de Ferias</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="end_date">Criado aos</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="duration">Actualizados</vs-th>
          <vs-th style="background-color: #ebe9f1;">Acções</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(item, index) in data" :key="index">
            <vs-td>{{ item.id }}</vs-td>
            <vs-td>{{ item.years_of_service }}</vs-td>
            <vs-td>{{ item.vacation_days }}</vs-td>
            <vs-td>{{ formatDate(item.created_at) }}</vs-td>
            <vs-td>{{ formatDate(item.updated_at) }}</vs-td>
            <vs-td>
              <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                <feather-icon icon="MenuIcon" svg-classes="h-4 w-4" class="ml-4 mr-4"></feather-icon>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="clickEditHandler(item)">
                    <span class="flex items-center">
                      <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-4 w-4" class="mr-2" />
                      <span>Editar</span>
                    </span>
                  </vs-dropdown-item>

                  <vs-dropdown-item @click="clickDeleteHandler(item)">
                    <span class="flex items-center">
                      <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-4 w-4" class="mr-2 " />
                      <span class="">Apagar</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>

          </vs-tr>
        </template>



      </vs-table>


      <div class="flex justify-between items-center">
        <label style="font-family: 'Arial', sans-serif; font-size: 13px; margin-left: 5px;" class="font-light">Mostrando
          {{ total }} de {{ perPage }} </label>
        <vs-pagination class="flex-1" style="margin-top: 10px;" v-model="currentPage" :total="lastPage" :per-page="perPage" @change="getVacations"
          :size="size" color="primary" :gradient="gradient" :rounded="rounded" :dense="dense"></vs-pagination>
      </div>

      <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
    </vs-card>


    <vs-popup class="holamundo" title="Editar Politica" v-model="popupEdit" :active.sync="popupEdit">

      <b-card-text class="text-warning">
        <p class="text-sm mt-2 text-info">
          Ao clicar em alterar esta concordando em altera a politica de ferias.
        </p>
      </b-card-text>


      <div class="vx-row mt-5">
        <div class="vx-col sm:1/2 w-full mb-2 ">
          <div class="vx-col w-full ">

            <label class="text-sm font-bold">Anos de Serviço</label>
            <div class="sub-label-container">
              <span><small class="text-sm text-gray-500">Por favor indique os anos de serviço</small></span>
            </div>
            <vs-input class="w-full" type="number" v-model="years_of_service" v-validate="'required|numeric'"
              name="Ano de Serviço" />

            <span class="text-danger text-sm" v-show="errors.has('Ano de Serviço')">{{ errors.first('Ano de Serviço')
            }}</span>
          </div>
        </div>

      </div>

      <div class="vx-row ">
        <div class="vx-col sm:1/2 w-full mb-2 ">
          <div class="vx-col w-full ">

            <label class="text-sm font-bold">Dias de Ferias</label>
            <div class="sub-label-container">
              <span><small class="text-sm text-gray-500">Por favor indique os dias de ferias</small></span>
            </div>
            <vs-input class="w-full" type="number" v-model="vacation_days" v-validate="'required|numeric'"
              name="Dias de Ferias" />
            <span class="text-danger text-sm" v-show="errors.has('Dias de Ferias')">{{ errors.first('Dias de Ferias')
            }}</span>
          </div>
        </div>

      </div>


      <div class="flex flex-wrap items-center flex-start">
        <vs-button type="filled" class="ml-auto mt-2" @click="editPolicy">Atualizar</vs-button>
        <vs-button class="ml-4 mt-2" type="filled" @click="cancelPopupApprove" color="danger">Cancelar</vs-button>
      </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Apagar Politica" v-model="popupDelete" :active.sync="popupDelete">

      <b-card-text class="text-warning">
        <p class="text-md mt-2 text-info">
          Tem certeza que deseja apagar esta politica? Esta actividade não podera ser revertida.
        </p>
      </b-card-text>

      <div class="flex flex-wrap items-center flex-start mt-5">
        <vs-button type="filled" class="ml-auto mt-2" @click="cancelVacation">Apagar</vs-button>
        <vs-button class="ml-4 mt-2" type="filled" @click="cancelPopupApprove" color="danger">Cancelar</vs-button>
      </div>
    </vs-popup>



  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import http from '../../../../http-common'
import http1 from '../../../../http1-common'
// Store Module

// Cell Renderer



export default {
  components: {
    AgGridVue,
    vSelect,
  },
  watch: {

  },
  data() {
    return {
      policies: [],
      popupEdit: false,
      popupDelete: false,
      lastPage: 0,
      currentPage: 1,
      perPage: 0, // Number of items to display per page
      total: 0, // Total number of items
      size: 'normal', // Pagination size
      gradient: false, // Enable gradient effect
      rounded: false, // Enable rounded corners
      dense: false, // Use compact pagination style
    }
  },

  mounted() {
    this.initialize();
  },


  computed: {

  },


  methods: {
    initialize() {
      this.getPolicies();
    },

    clickEditHandler(item) {
      // Display the popup model and pass the data from the current row
      this.popupEdit = true;
      this.years_of_service = item.years_of_service
      this.vacation_days = item.vacation_days
      this.selectedItem = item; // Store the current row data in a variable for display in the popup
    },
    clickDeleteHandler(item) {
      // Display the popup model and pass the data from the current row
      this.popupDelete = true;
      this.selectedItem = item; // Store the current row data in a variable for display in the popup
    },
    cancelPopupApprove() {
      this.popupDelete = false;
    },
    getPolicies() {
      this.$vs.loading()



      let token = localStorage.getItem("token");
      console.log("toquen =>", token)
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          page: this.currentPage,
          paginate: this.paginate,
        }
      };

      http1
        .get("/vacations/policies", config)
        .then((result) => {
          this.$vs.loading.close()
          this.policies = result.data.data;

          this.currentPage = result.data.current_page
          this.perPage = result.data.per_page
          this.total = result.data.total
          this.lastPage = result.data.last_page
          console.log('Policies', this.policies);
          // alert("2")
        })
        .catch((error) => {

          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { day: "numeric", month: "long", year: "numeric" };
      return date.toLocaleDateString("pt-PT", options); // Adjust the locale as needed
    },

    getStatusClass(status) {
      if (status === 'approved') {
        return 'vs-pill-success';
      } else if (status === 'pending') {
        return 'vs-pill-warning';
      } else if (status === 'rejected') {
        return 'vs-pill-danger';
      } else if (status === 'canceled') {
        return 'vs-pill-dark';
      }

      else {
        return '';
      }
    },

    getStatusName(status) {
      if (status === 'approved') {
        return 'Aprovado';
      } else if (status === 'pending') {
        return 'Pendente';
      } else if (status === 'rejected') {
        return 'Rejeitado';
      } else if (status === 'canceled') {
        return 'Cancelado';
      }

      else {
        return '';
      }
    },

    getTypeClass(type) {
      if (type === 'Singular') {
        return 'vs-pill-primary';
      } else if (type === 'Colectivas') {
        return 'vs-pill-secundary';
      } else {
        return '';
      }
    },

    editPolicy() {

      this.$vs.loading()
      setTimeout(() => {
        this.$vs.loading.close()
      }, 3000);
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      let data = {
        years_of_service: this.years_of_service,
        vacation_days : this.vacation_days,
      }
      

      this.$validator.validateAll();
      http1
        .put("/vacations/policies/" + this.selectedItem.id, data, config)
        .then((success) => {
          success;
          this.reason = '';
          this.$vs.loading.close();
          this.popupCancel = false;
          this.$vs.notify({
            title: "Sucesso",
            text: "Politica Atualizada Com Sucesso",
            color: "success",
            position: "top-right",
          });

          this.getPolicies()
          this.popupEdit = false


        })
        .catch((error) => {
          error;
          console.log("Error", error)
          this.err = error.response.data
          this.$vs.loading.close()
          this.$vs.notify({
            title: "Erro",
            text: this.err.message,
            color: "danger",
            position: "top-right",
          })

        });

    },




    cancelVacation() {

      this.$vs.loading()
      
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http1
        .delete("/vacations/policies/" + this.selectedItem.id, config)
        .then((success) => {
          success;
          this.reason = '';
          this.$vs.loading.close();
          this.popupCancel = false;
          this.$vs.notify({
            title: "Sucesso",
            text: "Politica apagada com sucesso",
            color: "success",
            position: "top-right",
          });

          this.getPolicies()
          this.popupDelete = false


        })
        .catch((error) => {
          error;
          console.log("Error", error)
          this.err = error.response.data
          this.$vs.loading.close()
          this.$vs.notify({
            title: "Erro",
            text: this.err.message,
            color: "danger",
            position: "top-right",
          })


        });




    },





  }
}

</script>

<style>
/* Add styles for the pill colors */
.vs-pill-success {
  background-color: #28CF6F;
  color: white;
  padding: 5px;
}

.vs-pill-danger {
  background-color: #EA5455;
  color: white;
}

.vs-pill-warning {
  background-color: rgb(255, 159, 67);
  color: white;
}

.vs-pill-dark {
  background-color: rgb(168, 170, 174);
  color: white;
}

.vs-pill-primary {
  background-color: #00CFE8;
  color: white;
}

.vs-pill-secundary {
  background-color: #A8AAAC;
  color: white;
}
</style>

